export =
    [
        {
            "fill": {
                "pattern": {
                    "orientation": "diagonal",
                    "color": "rgba(230,113,26,1)",
                    "spacing": 3,
                    "repitition": "repeat"
                }
            }
        }
    ];